// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// 定义语言包
const messages = {};

// 创建VueI18n实例并配置语言环境和语言包
const i18n = new VueI18n({
  locale: 'zh', // 设置当前语言环境为英文
  messages, // 设置语言包
  silentTranslationWarn: true
});


export default i18n;



// WEBPACK FOOTER //
// ./src/axios/i18n.js